const GA_SCRIPT_URL = 'https://www.ikea.com/se/sv/analytics/scripts/analytics-minor.min.js';
const TYPE = 'text/javascript';

/**
 * Utility class for loading the INGKA GA script, necessary for setting up Google Analytics.
 */
export default class GAScriptLoader {
	/**
	 * Check if the GA script is already loaded, and constructs and loads it if not.
	 *
	 * @returns The Promise from {@link constructScriptElement}, or an autoresolved Promise if already loaded.
	 */
	public async loadGoogleAnalyticsScript(): Promise<unknown> {
		let scriptLoaded = false;
		const scripts = document.getElementsByTagName('script');

		// Loop through all script tags
		Array.from(scripts).forEach(script => {
			if (script.src && script.src === GA_SCRIPT_URL && script.type && script.type === TYPE) {
				scriptLoaded = true;
			}
		});

		if (!scriptLoaded) {
			try {
				await this.constructScriptElement();
				return Promise.resolve();
			} catch (e) {
				return Promise.reject(e);
			}
		}
		return Promise.resolve();
	}

	/**
	 * Construct the script element, and appends it to document.head.
	 *
	 * @returns A promise for loading the script.
	 */
	private constructScriptElement(): Promise<unknown> {
		return new Promise((resolve, reject) => {
			const script = document.createElement('script');
			script.src = GA_SCRIPT_URL;
			script.type = TYPE;
			script.async = true;

			document.head.appendChild(script);

			script.addEventListener('load', () => {
				resolve(script);
			});

			script.addEventListener('error', () => {
				reject(new Error(`${GA_SCRIPT_URL} failed to load.`));
			});
		});
	}
}
